import React, { useState } from 'react';
import Navbar from './navbar';
import Footer from './footer';
import { fetchRefreshCache } from './services/refreshCacheService';
import { useNavigate } from 'react-router-dom';

const RefreshCache = () => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [strategyCode, setStrategyCode] = useState('');
  const [selectedCache, setSelectedCache] = useState('');
  const [selectedCacheItem, setSelectedCacheItem] = useState(''); // Track the selected cache item
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  // Function to handle the refresh operation
  const handleRefresh = async (cacheName, strategyCode = null) => {
    try {
      setLoading(true);
      const response = await fetchRefreshCache(cacheName, strategyCode);
      setShowModal(true);
      setMessage(response);
    } catch (error) {
      setShowModal(true);
      setMessage('Error refreshing cache. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Function to handle the click on the row (to show the popup if STRATEGY CODE is clicked)
  const handleCacheClick = (cacheName) => {
    if (cacheName === 'STRATEGY CODE') {
      setSelectedCache(cacheName);
      setShowPopup(true);  // Show the popup for entering strategy code
    } else {
      handleRefresh(cacheName); // Refresh the selected cache
    }
  };

  // Function to submit the strategy code and selected cache item in the popup
  const handlePopupSubmit = () => {
    if (strategyCode.trim() && selectedCacheItem) {
      handleRefresh(selectedCacheItem, strategyCode);
      setShowPopup(false); 
    } else {
      setShowPopup(false); // Close the popup after the action
      setStrategyCode(''); // Reset the strategy code input
      setSelectedCacheItem(''); // Reset the selected cache item
    }
  };

  const cacheItems = [
    { title: 'CATEGORIES', cacheName: 'categories' },
    { title: 'AVAILABLE_FACTOR', cacheName: 'availableFactor' },
    { title: 'STRATEGY', cacheName: 'strategy' },
    // Exclude STRATEGY CODE from this list to prevent it from appearing in the dropdown
  ];

  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
          <div className='d-flex justify-content-between' style={{ marginBottom: '10px', marginTop: '10px' }}>
            <button className="btn btn-primary d-flex justify-content-start" onClick={() => navigate(-1)}>
              Back
            </button>
            <h4 className="fw-bold">Refresh Cache</h4>
            <h4></h4>
          </div>

          <div className="table-responsive">
            <table className="table table-striped table-borderless">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {cacheItems.map((item, index) => (
                  <tr key={index}>
                    <td>{item.title}</td>
                    <td>
                      <button
                        className="btn btn-secondary"
                        onClick={() => handleCacheClick(item.cacheName)}
                        disabled={loading}
                      >
                        {loading ? 'Loading...' : 'Refresh'}
                      </button>
                    </td>
                  </tr>
                ))}
                {/* Include STRATEGY CODE row for clicking */}
                <tr>
                  <td>STRATEGY CODE</td>
                  <td>
                    <button
                      className="btn btn-secondary"
                      onClick={() => handleCacheClick('STRATEGY CODE')}
                      disabled={loading}
                    >
                      {loading ? 'Loading...' : 'Refresh'}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Popup for STRATEGY CODE refresh */}
          {showPopup && selectedCache === 'STRATEGY CODE' && (
            <div className="modal" style={{ display: 'block' }}>
              <div className="modal-dialog" style={{ maxHeight: '80%', margin: 'auto', marginTop: '100px' }}>
                <div className="modal-content" style={{ backgroundColor: '#e6e8ec' }}>
                  <div className="modal-header">
                    <h5 className="modal-title">Enter Strategy Code</h5>
                    <button type="button" className="btn-close" onClick={() => setShowPopup(false)}></button>
                  </div>
                  <div className="modal-body">
                    {/* Dropdown for cache item selection (Exclude STRATEGY CODE) */}
                    <div className="form-group">
                      <label htmlFor="cacheItem">Select Cache Item</label>
                      <select
                        id="cacheItem"
                        value={selectedCacheItem}
                        onChange={(e) => setSelectedCacheItem(e.target.value)}
                        className="form-control"
                        required
                      >
                        <option value="">Select Cache Item</option>
                        {cacheItems.map((item, index) => (
                          <option key={index} value={item.cacheName}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Input for Strategy Code */}
                    <div className="form-group mt-3">
                      <label htmlFor="strategyCode">Enter Strategy Code</label>
                      <input
                        type="text"
                        id="strategyCode"
                        value={strategyCode}
                        onChange={(e) => setStrategyCode(e.target.value)}
                        placeholder="Enter Strategy Code"
                        className="form-control"
                        required
                      />
                    </div>

                    <div className="mt-3">
                      <button className="btn btn-primary" onClick={handlePopupSubmit}>
                        Send
                      </button>
                      <button
                        className="btn btn-secondary ml-2"
                        onClick={() => setShowPopup(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showModal && (
            <div className="modal show d-block" tabIndex="-1">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Success</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>{message}</p>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        setShowModal(false); // Close the modal
                        window.location.reload(); // Reload the page
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
      <Footer />
    </>
  );
};

export default RefreshCache;
